import { render, staticRenderFns } from "./order-add-or-update.vue?vue&type=template&id=9998e622&scoped=true"
import script from "./order-add-or-update.vue?vue&type=script&lang=js"
export * from "./order-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./order-add-or-update.vue?vue&type=style&index=0&id=9998e622&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9998e622",
  null
  
)

export default component.exports